import React from 'react'
import Dropzone from 'react-dropzone'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createMedium } from 'redux/media'
import { Button } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { uploadingMedia, singleDropzoneUpload } = state.media
  return { uploadingMedia, singleDropzoneUpload }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      createMedium,
    },
    dispatch
  )
}

class UploadButton extends React.Component {
  render() {
    const { uploadingMedia, singleDropzoneUpload } = this.props
    const { createMedium } = this.props
    const mediaBrowserUpload = uploadingMedia && !singleDropzoneUpload
    return (
      <Dropzone
        onDrop={(accepted) => {
          createMedium(accepted)
        }}
        style={{}}
        activeClassName="valid"
        className="dropZone">
        <Button
          onClick={(e) => e.preventDefault()}
          loading={mediaBrowserUpload}
          icon={mediaBrowserUpload ? 'spinner' : 'cloud upload'}
          disabled={mediaBrowserUpload}
          primary
        />
      </Dropzone>
    )
  }
}

UploadButton = connect(mapStateToProps, mapDispatchToProps)(UploadButton)
export default UploadButton



// WEBPACK FOOTER //
// ./src/components/shared/MediaBrowser/UploadButton.jsx